<template>
  <div>
    <el-table
      :data="files"
      :empty-text="$t('sampleProgress.files.empty')"
    >
      <el-table-column :label="$t('sampleProgress.files.name')">
        <template #default="{ row }">
          <ProgressFileName :file="row" />
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('sampleProgress.files.step')"
        :formatter="formatStep"
      />
      <el-table-column
        :label="$t('sampleProgress.files.date')"
        :formatter="formatDate"
      />
      <el-table-column :label="$t('sampleProgress.files.revisions')">
        <template #default="{ row }">
          <el-button
            v-if="row.revisionCount > 1"
            type="text"
            @click="revisionsOf = row"
          >
            {{ $tc('sampleProgress.files.revisionCount', row.revisionCount) }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template #default="{ row }">
          <ProgressFileDownload
            :sample-id="sampleId"
            :file="row"
          />
        </template>
      </el-table-column>
    </el-table>
    <ProgressFileRevisions
      :sample-id="sampleId"
      :file="revisionsOf"
      @close="revisionsOf = null"
    />
  </div>
</template>

<script>
import ProgressFileDownload from '@/components/ProgressFileDownload.vue';
import ProgressFileName from '@/components/ProgressFileName.vue';
import ProgressFileRevisions from '@/components/ProgressFileRevisions.vue';
import progressFile from '@/services/progressFile';
import progressStep from '@/services/progressStep';

/**
 * The files forwarded to MyLab for the sample that it is given: one row per chain, on its current
 * revision, with the earlier revisions a click away.
 */
export default {
  name: 'ProgressFiles',
  components: {
    ProgressFileDownload,
    ProgressFileName,
    ProgressFileRevisions,
  },
  props: {
    sampleId: {
      type: Number,
      required: true,
    },
    // Rows of the samplefile view, newest first.
    files: {
      type: Array,
      required: true,
    },
    // The sample's reached steps: every file was received on one of them.
    steps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // The row whose revisions are open, if any.
      revisionsOf: null,
    };
  },
  computed: {
    stepLabels() {
      return Object.fromEntries(this.steps.map(step => [step.stepId, progressStep.label(step)]));
    },
  },
  methods: {
    formatStep({ stepId }) {
      return this.stepLabels[stepId];
    },
    formatDate(row) {
      return progressFile.date(row);
    },
  },
};
</script>
